import { Box } from '@mui/material'
import { CarrierType, JourneyCategory } from '@planning/app/api'
import { observer } from 'mobx-react-lite'
import { VesselVisitBulkEditFormStore } from '../../Stores/VesselVisitBulkEditFormStore'
import { VesselVisitBulkEditViewStore } from '../../Stores/VesselVisitBulkEditViewStore'
import { CargoSubFormSection } from './CargoSubForm/CargoSubFormSection'
import { InboundSubFormSection } from './InboundSubForm/InboundSubFormSection'
import { LogisticsSubFormSection } from './LogisticsSubForm/LogisticsSubFormSection'
import { OutboundSubFormSection } from './OutboundSubForm/OutboundSubFormSection'

interface BulkEditFormProps {
  formStore: VesselVisitBulkEditFormStore
  viewStore: VesselVisitBulkEditViewStore
  category: JourneyCategory
}

export const BulkEditForm = observer((props: BulkEditFormProps) => {
  const { formStore, viewStore, category } = props

  const getInboundDefaultCarrierType = (): CarrierType | undefined => {
    if (category === JourneyCategory.Import || category === JourneyCategory.Transshipment) {
      return CarrierType.Vessel
    }
    return undefined
  }

  const getOutboundDefaultCarrierType = (): CarrierType | undefined => {
    if (category === JourneyCategory.Export || category === JourneyCategory.Transshipment) {
      return CarrierType.Vessel
    }
    return undefined
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2 }}>
      <InboundSubFormSection
        store={formStore.inboundTransport}
        viewStore={viewStore}
        category={category}
        defaultCarrierType={getInboundDefaultCarrierType()}
      />

      <OutboundSubFormSection
        store={formStore.outboundTransport}
        viewStore={viewStore}
        category={category}
        defaultCarrierType={getOutboundDefaultCarrierType()}
      />

      <LogisticsSubFormSection store={formStore.logistics} category={category} />

      <CargoSubFormSection store={formStore.cargo} />
    </Box>
  )
})
